export default __webpack_public_path__ + "static/image-header-8e960546bbb4c20a25f14951cac5e687.png";